"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * Query scope for queryElements() API
 */
var QueryScope;
(function (QueryScope) {
    /**
     * Query from the whole body of root node. This is default value.
     */
    QueryScope[QueryScope["Body"] = 0] = "Body";
    /**
     * Query elements on a given selction (intersect)
     * The result element can contain the selection, contain part of selection, or inside selection
     */
    QueryScope[QueryScope["OnSelection"] = 1] = "OnSelection";
    /**
     * Query elements inside a given selection only
     */
    QueryScope[QueryScope["InSelection"] = 2] = "InSelection";
})(QueryScope = exports.QueryScope || (exports.QueryScope = {}));
//# sourceMappingURL=QueryScope.js.map